import { APIConstructor } from '@knitiv/api-client-javascript';

class APIWrapperV5Helper {
	constructor() {
		this.api = new APIConstructor();

		this.api.emitter.on('error', (/** @type {any} */ eventError) => {
			const { error, id } = eventError;

			const ignoreList = [
				'load-schema-node-from-k',
			];

			if (id && ignoreList.includes(id)) {
				return false;
			}

			// let's ignore load-schema-node-from-k request
			const User = this.$injector?.get('User');

			if (error.errno === 'NO_TOKEN') {
				return User.logout(error.errno);
			}

			if (error.errno === 'PASSWORD_MUST_CHANGE') {
				return User.logout(error.errno);
			}

			const Notification = this.$injector?.get('Notification');

			Notification.error({
				title: error.errno,
				message: error.errno_desc,
			});

			return false;
		});

		this.api.emitter.on('beforeRequest', (/** @type {any} */ request) => {
			if (request && request.options && !request.options.id) {
				console.error(`API call "${request.resource}" has no "id" context value. Please specify one.`);
			}
		});

		this.api.emitter.on('receivedRequestSuccess', (/** @type {any} */ responseData) => {
			// eslint-disable-next-line no-underscore-dangle
			if ('_NR_replace' in responseData && Object.keys(responseData._NR_replace).length > 0) {
				const $rootScope = this.$injector?.get('$rootScope');
				if ($rootScope) {
					// eslint-disable-next-line no-underscore-dangle
					$rootScope.$broadcast('Form.nrReplace', responseData._NR_replace);
				}
			}

			if ('UI' in responseData && responseData.UI.actions?.length > 0) {
				const UIActionService = this.$injector?.get('UIActionService');
				const $timeout = this.$injector?.get('$timeout');
				if (UIActionService && $timeout) {
					$timeout(async () => {
						/** @type {Function[]} */
						const promises = [];
						for (const action of responseData.UI.actions) {
							const method = UIActionService.methods[action.action];
							if (typeof method === 'function') {
								promises.push(() => method(action.params));
							}
						}
						await Promise.all(promises.map(x => x()));
					});
				}
			}
		});

		this.api.emitter.on('retry', (/** @type {any} */ {
			nextAttempt,
			attemptNumber,
			retry: maxRetries,
		}) => {
			const Notification = this.$injector?.get('Notification');
			const $translate = this.$injector?.get('$translate');
			const $filter = this.$injector?.get('$filter');

			if (attemptNumber > (maxRetries ?? 0)) {
				Notification.error({
					title: $translate.instant('error.title'),
					message: $translate.instant('error.network-disconnected'),
					replaceMessage: true,
				});
			}
			else if ($filter) {
				Notification.warning({
					title: $translate.instant('error.unable-to-process'),
					message: $filter('sprintf')(
						$translate.instant('error.network-attempt'),
						attemptNumber,
						maxRetries,
						nextAttempt / 1000,
					),
				});
			}
		});
	}

	get instance() {
		return this.api;
	}

	/**
	 *
	 * @param {import('angular').auto.IInjectorService} injector
	 */
	setInjector(injector) {
		this.$injector = injector;
	}
}

/**
 * @type {{ instance: import('@knitiv/api-client-javascript').APIConstructor }}
 */
const api = new APIWrapperV5Helper();

export default api;
